const TechnicalRole = {
  ADMIN: 'ADMIN',
  USER: 'USER',
} as const;
type TechnicalRole = typeof TechnicalRole[keyof typeof TechnicalRole];

const BusinessRole = {
  ADMIN: 'ADMIN',
  STANDARD: 'STANDARD',
  VIEWER: 'VIEWER',
  MANAGER: 'MANAGER',
  MEMBER: 'MEMBER',
} as const;
type BusinessRole = typeof BusinessRole[keyof typeof BusinessRole];

export const AclBusinessRoleType = {
  PUBLISHER: 'PUBLISHER',
  ADVERTISER: 'ADVERTISER',
  ORGANIZATION: 'ORGANIZATION',
} as const;
export type AclBusinessRoleType = typeof AclBusinessRoleType[keyof typeof AclBusinessRoleType];

export type AclResources = string[];

export interface IAclGroup {
  id: string;
  businessRoles: BusinessRole[];
  resources: AclResources;
  authGroupName: string;
}

export interface IAclByRoleType {
  items: IAclGroup[];
  roleType: AclBusinessRoleType;
}

export interface IAclRaw {
  generalResources: AclResources;
  technicalRoles: TechnicalRole[];
  // For organizations only
  groupAuthDto: IAclByRoleType[];
}

export type AclResourcesBitMap = {
  [resource: string]: boolean;
};

export type AclEntityResourceBitMap = {
  [entityId: string]: AclResourcesBitMap;
};
